module.exports = __webpack_public_path__ + "static/media/intro.395afeab.mp4";